import {Modal} from 'react-bootstrap';
import PolicyPDFViewer from '../PolicyPDFViewer';
import {useSelector} from 'react-redux';

const PrivacyModal = (props)=>{
  const hrMobileLanguage = useSelector((state) => state.app.slsHrMobileLanguage);

  return (
    <>
      <Modal
        show={props?.showModal}
        onHide={() => {
          props?.setShowModal(false);
        }}
        fullscreen={true}
      >
        <Modal.Header closeButton className='mt-2'>
          <Modal.Title>{hrMobileLanguage == 'en' ? 'Privacy Policy' : 'นโยบายความเป็นส่วนตัว'} </Modal.Title>
        </Modal.Header>
        <Modal.Body className='pb-0 pt-0'>
          <PolicyPDFViewer pdfUrl={`${process.env.PUBLIC_URL}/policy/policy-${hrMobileLanguage}.pdf`} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PrivacyModal;
